module.exports = __webpack_public_path__ + "static/img/indexVersion01.7f65f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexVersion01.jpg
// module id = 69UL
// module chunks = 3